import React from 'react';
import * as S from './CTACard.styles';

export interface CTACardContainerProps {
  children: React.ReactNode;
  className?: string;
}

const CTACardContainer: React.FC<CTACardContainerProps> = ({ children, className }) => {
  return <S.CTACardContainer className={className}>{children}</S.CTACardContainer>;
};

export default CTACardContainer;
